/// HOOKS ///
import { useAppDispatch } from "api/hooks/apiHook";
import { useAppSelector } from "api/hooks/apiHook";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useState } from "react";
/// ACTIONS ///
import { getAreas } from "api/actions/quotes/area";
import { getCounters } from "api/actions/sketch/counter";
import { getLabels } from "api/actions/sketch/label";
import { getQuote } from "api/actions/quotes/quote";
/// MUI COMPONENTS ///
import Box from "@mui/material/Box";
/// COMPONENTS ///
import LoadingPage from "components/universal/loading_page";
import QuotePrintPreviewBody from "./print_preview";
/// PDF ///
import { PDFViewer } from "@react-pdf/renderer";
/// FM ///
import { motion } from "framer-motion";
/// MOTION ///
import { m_init_page } from "motion/page";
import { m_anim_page } from "motion/page";
import { m_exit_page } from "motion/page";
import { page_trans } from "motion/page";
/// STYLES ///
import { content_container_style } from "styles/universal/page";

export default function QuotePrintPreview() {
  const dispatch = useAppDispatch();
  const [logo, setLogo] = useState<string | null>(null);
  const [logo_read, setLogoRead] = useState<boolean>(false);
  const { id } = useParams();
  const { user } = useAppSelector(state => state.authentication);
  const { counters } = useAppSelector(state => state.sketch);
  const { counters_loaded } = useAppSelector(state => state.sketch);
  const { labels } = useAppSelector(state => state.sketch);
  const { areas } = useAppSelector(state => state.quote);
  const { areas_loaded } = useAppSelector(state => state.quote);
  const { quote } = useAppSelector(state => state.quote);

  useEffect(() => {
    if (id) {
      dispatch(getQuote(id));
      dispatch(getCounters(id, null));
      dispatch(getAreas(id, null));
      dispatch(getLabels(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (user?.logo && typeof (user?.logo) === "string") {
      fetch(user.logo).then(response => {
        return response.blob();
      }).then(blob => {
        const blob_url: string = URL.createObjectURL(blob);
        setLogo(blob_url);
        setLogoRead(true);
      }).catch(() => {
        setLogoRead(true);
      })
    }
    else {
      setLogoRead(true);
    }
  }, [user]);

  return (
    <motion.div initial={m_init_page} exit={m_exit_page} animate={m_anim_page} transition={page_trans} style={content_container_style}>
      <LoadingPage loading={!quote?.id || !user?.id || !logo_read || !counters_loaded || !areas_loaded}>
        <Box display="flex" justifyContent="center">
          <PDFViewer width="795px" height="1123px">
            <QuotePrintPreviewBody areas={areas} counters={counters} user={user} quote={quote} labels={labels} logo={logo} />
          </PDFViewer>
        </Box>
      </LoadingPage>
    </motion.div>
  );
}
